class CollectionFiltering {
  constructor() {
    this.selectors = {
      sortBy: '#SortBy',
      productGrid: '#product-grid',
      filterForm: '#FilterForm',
      productCount: '.product-count',
      loadMoreBtn: '.load-more-btn'
    };

    this.currentUrl = window.location.href;
    this.init();
  }

  init() {
    // Sort by change handler
    const sortSelect = document.querySelector(this.selectors.sortBy);
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => this.onSortChange(e));
    }

    // Load more button handler
    const loadMoreBtn = document.querySelector(this.selectors.loadMoreBtn);
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', (e) => this.onLoadMore(e));
    }

    // Filter form change handler
    const filterForm = document.querySelector(this.selectors.filterForm);
    if (filterForm) {
      filterForm.addEventListener('change', (e) => this.onFilterChange(e));
    }
  }

  onSortChange(event) {
    event.preventDefault();
    const sortBy = event.target.value;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortBy);
    this.fetchPage(url.toString());
  }

  onLoadMore(event) {
    event.preventDefault();
    const nextPageUrl = event.target.getAttribute('href');
    if (nextPageUrl) {
      this.fetchPage(nextPageUrl, true);
    }
  }

  onFilterChange(event) {
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const url = `${window.location.pathname}?${searchParams.toString()}`;
    this.fetchPage(url);
  }

  async fetchPage(url, isLoadMore = false) {
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update product grid
      const newProducts = doc.querySelector(this.selectors.productGrid);
      if (newProducts) {
        if (isLoadMore) {
          // Append new products for load more
          const productGrid = document.querySelector(this.selectors.productGrid);
          productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        } else {
          // Replace entire grid for sorting/filtering
          document.querySelector(this.selectors.productGrid).innerHTML = newProducts.innerHTML;
        }
      }

      // Update URL
      window.history.pushState({}, '', url);

      // Update product count if it exists
      const newCount = doc.querySelector(this.selectors.productCount);
      const currentCount = document.querySelector(this.selectors.productCount);
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }

      // Initialize any product card functionality
      this.initProductCards();

    } catch (error) {
      console.error('Error fetching collection page:', error);
    }
  }

  initProductCards() {
    // Re-initialize any product card specific functionality
    if (window.Currency && window.Currency.convertAll) {
      window.Currency.convertAll();
    }
    
    // Re-initialize quick view buttons
    const quickViewButtons = document.querySelectorAll('.quick-view-btn');
    quickViewButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Your quick view logic here
      });
    });
  }
}

// Initialize collection filtering when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFiltering();
}); 